import { format, differenceInMinutes } from 'date-fns'

// eg: 25/12/2024
export function formatDate(date, { style = "short" } = {}) {
  return new Intl.DateTimeFormat("en-GB", { dateStyle: style }).format(new Date(date))
}

// eg: 25/12/2024 10:00
export function formatDateTime(date) {
  return new Intl.DateTimeFormat("en-GB", { dateStyle: "short", timeStyle: "short" }).format(new Date(date))
}

export function formatDateText(date) {
  return new Intl.DateTimeFormat("en-GB", { dateStyle: "long" }).format(new Date(date))
}

export function formatTime(date, { mode = "24h" } = {}) {
  if (mode === "12h") return format(new Date(date), 'h:mm a')
  return new Intl.DateTimeFormat("en-GB", { timeStyle: "short" }).format(new Date(date))
}

export function formatEventTime(start_time, end_time, { returns = "string"} = {}) {
  const parts = { date: formatDate(start_time), start: formatTime(start_time), end: formatTime(end_time) }
  if (returns === "parts") return parts
  return `${parts.date} - ${parts.start} - ${parts.end}`
}

export function ago(date) {
  return new Intl.RelativeTimeFormat("en-GB").format(-Math.round((new Date() - new Date(date)) / (1000 * 60 * 60 * 24)), "day")
}

export function formatDuration(start_time, end_time) {
  if (!start_time || !end_time) return ''
  const mins = differenceInMinutes(new Date(end_time), new Date(start_time))
  if (mins >= 60) {
    const hrs = Math.floor(mins / 60)
    const rem = mins % 60
    return rem > 0 ? `${hrs}h ${rem}m` : `${hrs}h`
  }
  return `${mins}m`
}